<template>
  <div style="padding: 15px;">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="100px"
      he
    >
      <el-col :span="24">
        <el-form-item
          label="货源单号："
          prop="mainOrderNumber"
        >
          <el-input
            v-model="form.mainOrderNumber"
            :disabled="true"
          />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item
          label="运输单号："
          prop="orderCode"
        >
          <el-input
            v-model="form.orderCode"
            :disabled="true"
          />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item
          label="手机号："
          prop="phone"
        >
          <el-input
            v-model="form.phone"
            :disabled="true"
          />
        </el-form-item>
      </el-col>
      <el-col :span="20">
        <el-form-item
          label="获取验证码："
          prop="smsCode"
        >
          <el-input
            v-model="form.smsCode"
            maxlength="20"
            placeholder="请输入验证码"
          />
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <div class="grid-content bg-purple-light">
          <!-- <span
            v-show="show"
            @click="getCode"
            style="height: 40px;line-height: 40px;display: block;padding-left: 5px;"
          >获取验证码</span> -->
          <el-button
            v-show="show"
            type="primary"
            round
            size="small"
            @click="getCode"
          >
            获取验证码
          </el-button>
          <span
            v-show="!show"
            style="height: 40px;line-height: 40px;display: block;padding-left: 5px;"
          >{{ count }} s</span>
        </div>
      </el-col>
      <el-col :span="24">
        <el-button
          type="primary"
          :disabled="updating"
          @click="funcSubmit('form')"
        >
          确定
        </el-button>
      </el-col>
    </el-form>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: "Sms",
  data() {
    return {
      show: true,
      count: "",
      loading: false,
      updating: true,
      form: {
        phone: "",
        code: "",
        smsCode: "",
        orderCode: "",
        mainOrderNumber: ""
      },
      Pagingconf: [],
      rules: {
        smsCode:[
          { required: true, message: "请输入验证码", trigger: "blur" },
        ]
      }
    };
  },
  methods: {
    getInfo(row) {
      this.row = row;
      this.form.code = row.code;
      this.form.phone = row.driverPhone;
      this.form.smsCode = "";
      this.form.mainOrderNumber = row.mainOrderNumber;
      this.form.orderCode = row.orderCode;
    },
    close() {
      this.count = 0;
      this.updating = true;
    },
    //获取验证码
    getCode() {
      const $this = this;
      const rLoading = $this.openLoading();
      request({
        url: `/ntocc-tps-api/elecSign/sendSms`,
        method: "put",
        params: { "code": this.form.code }
      }).then(response => {
        rLoading.close();
        this.$message({ message: response.msg, type: "success" });
        $this.updating = false;
        if (response.status == 0) {
          const TIME_COUNT = 60;
          if (!$this.timer) {
            $this.count = TIME_COUNT;
            $this.show = false;
            $this.timer = setInterval(() => {
              if ($this.count > 0 && $this.count <= TIME_COUNT) {
                $this.count--;
              } else {
                $this.show = true;
                clearInterval($this.timer);
                $this.timer = null;
              }
            }, 1000);
          }
        }
      });
    },
    // 提交
    funcSubmit(form) {
      //console.log(this.form.smsCode);
      this.$refs["form"].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          request({
            url: `/ntocc-tps-api/elecSign/eSign`,
            method: "put",
            params: { "code": this.form.code , "smsCode" : this.form.smsCode}
          }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.$emit("hideModel");
            rLoading.close();
            this.updating = true;
            this.count = 0;
          });
        } else {
          return false;
        }
      });
    },

    isFloor(e) {
        e.target.value = e.target.value.match(/^\d*(\.?\d{0,1})/g)[0] || null;
    }
  }
};
</script>
